// error-handler.js (or error-handler.jsx if you prefer the .jsx extension)
function handleAxiosError(error, context = "Request") {
    console.error(`Error in ${context}:`, error.message);
  
    if (error.response) {
      console.error(`Server responded with status: ${error.response.status}`);
      console.error(`Server response data:`, error.response.data);
      if (error.response.data && error.response.data.message) {
        throw new Error(error.response.data.message);
      }
    } else if (error.request) {
      console.error("Request was made but no response was received");
      console.error("Error details:", error.request);
    } else {
      console.error("Error setting up the request");
    }
  
    throw new Error(`Error in ${context}`);
  }
  
  export default handleAxiosError; // or export { handleAxiosError };